export enum Catalog {
  INDEX = '/catalog',
  CASINO = '/catalog/casino',
  SPORTS = '/catalog/sports',
}
